module.exports = __webpack_public_path__ + "img/4_90.54c2339c.png";